export default class ServiceTags extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.serviceBlocks = this.serviceBlocks.bind(this);
    this.serviceBlock = this.serviceBlock.bind(this);
    this.tagsToRender = this.tagsToRender.bind(this);
    this._isChecked = this._isChecked.bind(this);
    this.isTreatmentProfiles = this.isTreatmentProfiles.bind(this);
    this.state = {
      searchQuery: '',
      filteredServices: this.props.campServiceTags,
      grouped: false,
    };
    this.max_services_count = 5;
  }

  isTreatmentProfiles() {
    return this.props.service_name === 'Профили лечения';
  }

  handleChange(event) {
    let newValue = [...(this.props.value || [])];

    if (event.target.checked) {
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter((v) => v != event.target.value);
    }

    return this.props.filter(this.props.condition_param, newValue.length === 0 ? false : newValue);
  }

  _isChecked(id) {
    return (this.props.value || []).includes(String(id));
  }

  serviceBlock(service_tag, i) {
    // Найти индекс в исходном списке
    const originalIndex = this.props.campServiceTags.findIndex((tag) => tag.id === service_tag.id);

    let hidden_class = i + 1 > this.max_services_count && !this.state.grouped ? 'hidden' : '';

    return (
      <div
        className={`mdc-form-field filter-row__check ${hidden_class}`}
        key={i}
        onClick={() => {
          $(`.input_campServiceTags${service_tag.main_id}-${originalIndex}`).each(function () {
            $(this).trigger('click');
          });
        }}
      >
        <div className='mdc-checkbox'>
          <input
            className={`mdc-checkbox__native-control input_campServiceTags${service_tag.main_id}-${originalIndex}`}
            type='checkbox'
            onClick={(event) => {
              event.stopPropagation();
            }}
            onChange={this.handleChange}
            value={service_tag.id}
            checked={this._isChecked(service_tag.id)}
            data-id={service_tag.id}
          />
          <div className='mdc-checkbox__background'>
            <svg className='mdc-checkbox__checkmark' viewBox='0 0 24 24'>
              <path className='mdc-checkbox__checkmark-path' fill='none' d='M1.73,12.91 8.1,19.28 22.79,4.59' />
            </svg>
            <div className='mdc-checkbox__mixedmark'></div>
          </div>
        </div>
        <label className='mdc-checkbox__label'>
          {service_tag.name}&nbsp;&nbsp;
          {this.props.counts && !this._isChecked(service_tag.id) && (
            <span className={'mdc-checkbox__label-count'}>{this.props.counts[service_tag.id] ?? 0}</span>
          )}
        </label>
      </div>
    );
  }

  tagsToRender() {
    const tags = this.state.searchQuery ? this.state.filteredServices : this.props.campServiceTags;

    if (!this.props.counts) {
      return tags;
    } else if (this.isTreatmentProfiles() && Array.isArray(this.props.value) && this.props.value.length) {
      const filteredTags = [];

      // Объединяем сортировку и фильтрацию в один цикл для оптимизации:
      let selectedTagsInserted = 0;
      for (const campServiceTag of tags) {
        if (this.props.value.includes(campServiceTag.id)) {
          filteredTags.splice(selectedTagsInserted++, 0, campServiceTag);
        } else if (this.props.counts[campServiceTag.id] > 0) {
          filteredTags.push(campServiceTag);
        }
      }

      return filteredTags;
    } else {
      return tags.filter((item) => this.props.counts[item.id] > 0);
    }
  }

  serviceBlocks(showSearch = false) {
    const servicesToRender = this.tagsToRender();

    if (showSearch && !this.props.baths) {
      servicesToRender.sort((a, b) => a.name.localeCompare(b.name));
    }

    if (this.state.grouped && showSearch) {
      // Группируем услуги по категориям
      const groupedServices = servicesToRender.reduce((acc, service_tag) => {
        const categoryName = service_tag.category_name;
        if (!acc[categoryName]) acc[categoryName] = [];
        acc[categoryName].push(service_tag);
        return acc;
      }, {});

      const sortedCategories = Object.entries(groupedServices).sort(([a], [b]) => a.localeCompare(b));

      return sortedCategories.map(([category, services], categoryIndex) => (
        <div className='filter-row__search-block' key={`category-${categoryIndex}`}>
          <div className='filter-row__category-name'>{category}</div>
          {services.map((service_tag, i) => this.serviceBlock(service_tag, i))}
        </div>
      ));
    } else {
      return servicesToRender.map((service_tag, i) => {
        return this.serviceBlock(service_tag, i);
      });
    }
  }

  moreButton() {
    const servicesToRender = this.tagsToRender();

    const btnClassName = this.state.grouped ? 'collapse-btn filter-row__collapse' : 'show-more-btn';

    if (servicesToRender.length <= this.max_services_count) {
      return null;
    }

    return (
      <div style={{ marginTop: '10px' }}>
        <a className={btnClassName} role='button' onClick={() => this.setState({ grouped: !this.state.grouped })}>
          {this.state.grouped ? 'Свернуть' : 'Показать еще'}
        </a>
      </div>
    );
  }

  handleSearch(event) {
    const query = event.target.value.toLowerCase();
    const isSearchEmpty = query.trim() === '';

    const filteredServices = isSearchEmpty
      ? this.props.campServiceTags
      : this.props.campServiceTags
        .filter((tag) => tag.name.toLowerCase().includes(query))
        .filter((item) => !this.props.counts || this.props.counts[item.id] > 0).slice(0, 5);

    this.setState((prevState) => ({
      searchQuery: query,
      filteredServices,
      grouped: !isSearchEmpty,
    }));
  }

  render() {
    const showSearch =
      this.props.service_name === 'Услуги' &&
      this.props.user_show_filter !== undefined &&
      this.props.user_show_filter !== false;

    const tags = this.tagsToRender();
    const noResults = tags.length === 0;

    if (showSearch) {
      return (
        <div
          className={`filter-row filter-row_blocks ${this.props.hide_service_name ? 'all-categories-filter' : ''}
          ${this.state.grouped ? 'filter-row_expanded' : ''}`}
        >
          <div className='filter-row__block'>
            <div
              className={`${this.props.hide_service_name ? 'filter-row__title-all-categories' : 'filter-row__title'}`}
            >
              {this.props.service_name}
            </div>
            {
              <div className='filter-row__search-container'>
                <div className='filter-row__search-services'>
                  <div className='filter-row__input-container'>
                    <input
                      type='text'
                      className='filter-row__search-input'
                      value={this.state.searchQuery}
                      onChange={(event) => this.handleSearch(event)}
                      style={{ width: '100%' }}
                    />
                    {!this.state.searchQuery && <span className='filter-row__placeholder'>Найти</span>}
                  </div>
                </div>
              </div>
            }
          </div>

          <div className='filter-row__content'>{noResults ? null : this.serviceBlocks(showSearch)}</div>
          <div className='filter-row__block'>{!noResults && this.moreButton()}</div>
        </div>
      );
    } else {
      return (
        <div className={`filter-row ${this.props.hide_service_name ? 'all-categories-filter' : ''}`}>
          <div className={`${this.props.hide_service_name ? 'filter-row__title-all-categories' : 'filter-row__title'}`}>
            {this.props.service_name}
          </div>
          {noResults ? null : this.serviceBlocks()}
          {!noResults && this.moreButton()}
        </div>
      );
    }
  }
}
